import React from 'react';
import AddExistingInvestorSummary from './AddExistingInvestorSummary';
import { withStyles } from '@material-ui/core/styles';
import { FormSpy } from 'react-final-form';
import CustomSimpleForm from '../../../core/components/form/CustomSimpleForm';

const styles = () => ({
  fullWidth: {
    width: '100%'
  },
  form: {
    '& > div': {
      paddingTop: '0px !important',
      paddingBottom: '0px !important'
    }
  }
});

const AddExistingInvestorForm = props => {
  const { handleSubmit, setInvestorFormProps, investorId, classes } = props;
  return (
    <CustomSimpleForm
      toolbar={null}
      // We override the redux-form name to avoid collision with the react-admin main form
      resource="investors"
      // We override the redux-form onSubmit prop to handle the submission ourselves
      save={handleSubmit}
      className={classes.form}
      variant="standard"
      margin="normal"
    >
      <FormSpy>
        {props => {
          setInvestorFormProps(props);
          return (
            <AddExistingInvestorSummary {...props} investorId={investorId} />
          );
        }}
      </FormSpy>
    </CustomSimpleForm>
  );
};

export default withStyles(styles)(AddExistingInvestorForm);
